import { env } from "@/config/env";
import mixpanel from "mixpanel-browser";

export const useMixPanelInit = () => {
	const { MIXPANEL_TOKEN } = env;

	if (MIXPANEL_TOKEN) {
		mixpanel.init(MIXPANEL_TOKEN, {
			debug: true,
			track_pageview: true,
			persistence: "localStorage",
		});
	}
};
